// VasUnderFleet.js
import React, { useContext, useEffect, useState } from "react";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import ServiceSchedule from "../../components/Table/ServiceSchedule";
import Renewal from "../../components/Table/Renewal";
import VehicleCount from "../../components/Table/VehicleCount";
import { getVasTablesDetails } from "./VasUnderFleetKpi";
import { FilterContext } from "../../context/Filter";
import Header from "../../components/Header/Header";
import NavButtons from "../../components/NevBar/NavButtons";
import WaterMark from "../../components/WaterMark";

const SectionToggle = ({ title, isOpen, onToggle, component }) => (
  <div className="flex flex-col items-center gap-2 w-full">
    <div
      onClick={onToggle}
      className="bg-[#1863a8] text-white font-semibold rounded-md p-3 flex items-center justify-between min-h-[48px] max-w-[950px] w-full w-full cursor-pointer transition-all"
    >
      <span className="text-sm font-medium">{title}</span>
      <div className="bg-white p-1 rounded-md text-[#1863a8] transition-all flex items-center justify-center">
        {isOpen ? (
          <IoIosArrowDown size={20} />
        ) : (
          <IoIosArrowForward size={20} />
        )}
      </div>
    </div>
    {isOpen && (
      <div className="w-full">
        {component}
      </div>
    )}
  </div>
);

const VasUnderFleet = () => {
  const { arn: parArn, childArn } = useContext(FilterContext);
  const [tableValues, setTableValues] = useState(null);
  const [openSections, setOpenSections] = useState({
    service: false,
    renewals: false,
    vehicleCount: false,
  });

  const vasTableDetails = async () => {
    try {
      const res = await getVasTablesDetails(parArn, childArn);
      setTableValues(res);
    } catch (error) {
      console.error("Error fetching total complaints data:", error);
    }
  };

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  useEffect(() => {
    vasTableDetails();
  }, []);

  //console.log("Table Values", tableValues);

  return (
    <div>
      <WaterMark />
      <WaterMark />

      <Header heading={"VAS"} />
      <div className="flex flex-col items-center gap-6 w-96 md:w-[1200px] p-4">
        <SectionToggle
          title="Vehicles Due For Scheduled Service In Next 30 Days"
          isOpen={openSections.service}
          onToggle={() => toggleSection("service")}
          component={
            <ServiceSchedule data={tableValues?.serviceScheduleTableValues} />
          }
        />
        <SectionToggle
          title="Vehicles Due For Contract Renewal in Next 30 Days"
          isOpen={openSections.renewals}
          onToggle={() => toggleSection("renewals")}
          component={<Renewal data={tableValues?.renewalsTableTableValues} />}
        />
        <SectionToggle
          title="Vehicle Count"
          isOpen={openSections.vehicleCount}
          onToggle={() => toggleSection("vehicleCount")}
          component={
            <VehicleCount data={tableValues?.vehicleCountTableTableValues} />
          }
        />
      </div>
      <div className="translate-y-24">
        <NavButtons />

      </div>
    </div>

  );
};

export default VasUnderFleet;
